import GeoJSON from 'ol/format/GeoJSON';
import { getAllFeatures } from '../Llegenda/CapaLlegenda/CapaLlegendaFooter/Components/Taula/TaulaUtils';

export const getLayerBboxWFS = async (filtre, layer) => {
  let fc = new GeoJSON().readFeatures(await getAllFeatures(layer, filtre));
  return getFeaturesExtent(fc);
};

export const getFeaturesExtent = (fc) => {
  let extent = '';
  fc.forEach((feature) => {
    let geometria = feature.getGeometry();
    if (geometria !== undefined) {
      if (extent === '') {
        extent = geometria.getExtent();
      } else {
        let aux = geometria.getExtent();
        if (aux[0] < extent[0]) extent[0] = aux[0];
        if (aux[1] < extent[1]) extent[1] = aux[1];
        if (aux[2] > extent[2]) extent[2] = aux[2];
        if (aux[3] > extent[3]) extent[3] = aux[3];
      }
    }
  });
  return extent;
};
